// extracted by mini-css-extract-plugin
export default {"SubSection":"WildlifeManagement-PDF-style_SubSection__SayHL","Disclaimer":"WildlifeManagement-PDF-style_Disclaimer__MRo-A","Bordered":"WildlifeManagement-PDF-style_Bordered__E7Ptv"};